module.exports = __webpack_public_path__ + "img/chest_hover.6d642f6e.png";